import MeetingEnded from '../../assets/svg/LeaveMeeting.svg';
import { useNotFoundStyles } from '../../styles/muiStyles';
import { Button, Typography } from '@material-ui/core';
import NEUniteLogo from '../../assets/svg/Logo.svg'

const LeaveMeeting = () => {
  const classes= useNotFoundStyles();
  const handleClose = () => {
    window.close();
  }
  return (
    <div>
      <div style={{display:'flex',alignItems:'center',}}>
        <img src={NEUniteLogo} alt="logo" style ={{width:'6vw', height:'6vw', margin:'1.5vw'}} />
        <Typography variant='h6' style={{color:'white',textShadow: '2px 2px #000', letterSpacing:'.3vw'}}>
              <strong> <i>NEUMeet</i></strong>
        </Typography>
      </div>
      <div className = {classes.root} >
        <div>
          <img src={MeetingEnded} alt="Meeting Ended " />
        </div>
        <div>
          <Typography variant='h6' style ={{margin:'1vw', textAlign:'center',textShadow: '1px 1px #000', letterSpacing:'.3vw'}}>
            <strong> <i>YOU LEFT THE MEETING </i></strong>
          </Typography>
        </div>
        <div>
          <Button
            color="secondary"
            variant="contained"
            size="large"
            onClick={handleClose}>
            CLOSE PAGE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LeaveMeeting;
